import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getConsent } from "@/components/CookieConsent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let v = localStorage.getItem("sp_vid");
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem("sp_vid", v);
  }
  return v;
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // GDPR: analytics are non-essential — nothing tracks until the user opts in
    const consent = getConsent();
    if (!consent?.choices?.analytics) return;
    // capture landing referrer + UTMs once
    if (!localStorage.getItem("sp_ref")) {
      const p = new URLSearchParams(window.location.search);
      localStorage.setItem("sp_ref", document.referrer || "(direct)");
      for (const k of ["utm_source", "utm_medium", "utm_campaign"]) {
        const v = p.get(k);
        if (v) localStorage.setItem(`sp_${k}`, v);
      }
    }
    const payload = {
      path: location.pathname,
      referrer: localStorage.getItem("sp_ref") || "",
      utm_source: localStorage.getItem("sp_utm_source") || "",
      utm_medium: localStorage.getItem("sp_utm_medium") || "",
      utm_campaign: localStorage.getItem("sp_utm_campaign") || "",
      visitor_id: getVisitorId(),
    };
    fetch(`${API}/analytics/pv`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname]);

  return null;
}
